/**
 * @typedef {import('../../types').Component} Component
 * @typedef {import('../../types').FeedbackEntity} FeedbackEntity
 */

/**
 *
 * @param {Component[] | null | []} pageRequiredComponents - components
 * @param {FeedbackEntity[]}  submittedComponents - components
 * @returns {boolean} is valid
 */
function shouldAllowProgress(pageRequiredComponents, submittedComponents) {
  if (!pageRequiredComponents?.length) {
    return true;
  }
  if (!submittedComponents?.length) {
    return false;
  }
  if (submittedComponents.length >= pageRequiredComponents.length) {
    return true;
  }
  return false;
}
export default shouldAllowProgress;
